var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},[_c('youtube',{ref:"youtube",staticStyle:{"margin":"auto"},attrs:{"video-id":_vm.videoId,"width":700}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }